import React from "react";

const ContactPage = () => {
  return (
    <div className="min-h-screen text-black flex items-center justify-center px-4 py-10 bg-white">
      <div className="w-full max-w-4xl bg-white text-black rounded-2xl p-8 md:p-12 shadow-lg">
        <h2 className="text-3xl font-bold text-center mb-8 text-black uppercase">Contact Us</h2>
        
        <div className="w-full">
          <h5 className="text-xl mb-4 uppercase tracking-widest">Contact Details</h5>

          <p className="text-sm mb-2">
            <i className="fa fa-map-marker-alt"></i>
            12th Floor, Unit No. 25, Building No.9, Tower B, DLF Cyber City, Phase III, GURGAON - 122002, Haryana, India.
          </p>

          <p className="text-sm mb-2">
            <i className="fa fa-envelope "></i>
            <a
              href="mailto:admin@cruze.asia"
              className="text-black hover:underline"
            >
              admin@cruze.asia
            </a>
          </p>

          <h6 className="text-sm mt-6 mb-3 uppercase tracking-widest">Phone Number</h6>
          <p className="text-sm mb-3">
           8217639080
          </p>
          <h6 className="text-sm mt-6 mb-3 uppercase tracking-widest">Newsletter</h6>
          <p className="text-sm mb-3">
            Stay updated with the latest news and offers from WMD Services India Private Limited.
          </p>
          <a
            href="https://wmdservices.asia/"
            className="bg-gray-700 text-white py-2 px-4 rounded hover:bg-gray-600 transition inline-block"
            target="_blank"
            rel="noopener noreferrer"
          >
            Visit WMD Services
          </a>
        </div>
      </div>
    </div>
  );
};

export default ContactPage;
